// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import * as React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import Button from "@directv-digital/fusion.atoms.button";
import type { IDtvButtonProps } from "@directv-digital/dds.ui.dtv-button";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import DtvText, { IDtvTextProps } from "@directv-digital/dds.ui.dtv-text";
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import {
  Analytics,
  LINK_POSITION_BODY,
  fireCustomLinkClickGA,
  constructFullUrl,
  getAnalyticsAttrs
} from "@directv-digital/dds.services.analytics-service";
import Link from "@mui/material/Link";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import useMediaQuery from "@mui/material/useMediaQuery";
import DtvCountdownTimer, { DtvCountdownProps } from "@directv-digital/dds.ui.dtv-countdown";

export interface DtvContentCardsProps {
  id?: any;
  cards?: Array<CardUI>;
  analytics?: Analytics;
  spacer?: any;
  isFullWidth?: any;
  aboveTheFold?: boolean;
}
interface CardUI {
  variant?: any;
  backgroundColor?: any;
  gradientStop1?: GradientByBreakpoints;
  gradientStop2?: GradientByBreakpoints;
  eyebrow?: any;
  headline?: any;
  subheadline?: any;
  body?: any;
  image?: Image;
  cta?: IDtvButtonProps;
  optionalCTA?: IDtvButtonProps;
  featuredLogos?: Array<Image>;
  bullets?: Array<Text>;
  flipDirection?: any;
  isBulletFullwidth?: any;
  isHeadlineFullwidth?: any;
  ctaAlignment?: any;
  countdownTimer?: DtvCountdownProps;
  legalText?: IDtvTextProps;
  overrideExpiredCountdownTimerContent?: any;
  mode?: "light" | "dark";
  customHeightFor2up?: any;
  v2Styles?: V2Styles;
  contentOrder?: any;
  enableFullWidthBgImg?: boolean;
  contentAlignment?: "left" | "center" | "right";
}
interface V2Styles {
  height?: any;
  width?: any;
  maxWidth?: any;
  bodyTextSize?: any;
  padding?: any;
}
interface Text {
  bulletText?: any;
}
interface GradientByBreakpoints {
  FromDesktop?: any;
  BelowDesktop?: any;
}
interface Image {
  imageUrl?: any; // Tablet, mobile & 2up
  imageAlt?: any;
  imgDesktop1UpOnlyUrl?: any; // Desktop with 1up only
  imgDesktop1UpOnlyAlt?: any;
  optionalImageUrl?: any;
  optionalImageAlt?: any;
  imageTargetUrl?: any;
  tabletImgUrl?: any;
}
interface LinkAnalytics {
  [key: string]: string | number;
}
enum variants {
  v1 = "CC-Headline-CTA",
  v2 = "CC-Headline-Body-CTA",
  v3 = "CC-Eyebrow-Headline-CTA",
  v4 = "CC-FeatureLogos",
  v5 = "CC-Bullets",
  v6 = "CC-Service-Cards",
  v7 = "CC-Left-Image",
  v8 = "CC-Auth-LeftAlign",
  v9 = "CC-tvguide-variation",
  v10 = "CC-1up-Bullet",
  v11 = "CC-Countdown",
  v12 = "CC-Countdown-Full",
  v13 = "CC-ProductCard-Horizontal",
  v14 = "CC-TangerineVariant",
  v15 = "CC-TangerineEnhancedLeft"

}

const TANGERINE_V15_EYEBROW_SX = {
  textAlign: {
    xs: "center",
    sm: "left",
    md: "left"
  },
  alignItems: {
    xs: "center",
    sm: "flex-start",
    md: "flex-start"
  },
  pt: {
    xs: "0px",
    sm: "0px",
    md: "0px"
  },
  pb: {
    xs: "0px",
    sm: "0px",
    md: "0px"
  }
};
const TANGERINE_V15_CTA_HEIGHT = "48px";

const CtaContainer = ({
  card,
  id,
  isv3V4TwoUp,
  isOneUpBullet,
  isTwoUp,
  analytics: _analytics,
  index,
  hideXS
// eslint-disable-next-line complexity
}) => {
  try{
    const cardVariant = card?.variant;
    const isTangerineV14 = cardVariant === variants.v14;
    const isTangerineV15 = cardVariant === variants.v15 || cardVariant === "CC-TangerineEnhancedLeft";
    const isTangerineV15FullwidthImage =
    isTangerineV15 && card?.enableFullWidthBgImg === true;
    const fwContentAlignment = isTangerineV15FullwidthImage ?
      (card?.contentOrder?.content === 0 ? "center" : card?.contentOrder?.content === 2 ? "right" : "left") :
      "left";
    // Temporary workaround until the issue is fixed in the CMS or at the Fusion button level
    const fusionBtnMode = (['jet.main', 'lapis.main', 'black.main'].includes(card.backgroundColor)) ? 'dark' : undefined;
    return (
    <DtvBox
      className={`${id}-cta-container`}
      sx={{
        width: {
          xs:
            card?.variant === variants.v7 || card?.variant === variants.v10 || card?.variant === variants.v15 ?
              "100%" :
              "unset",
          sm: "unset",
          ...((card?.cta?.imageUrl || card?.optionalCTA?.imageUrl) && {
            xs: "100%",
            sm: "unset"
          }),
          ...(card?.variant === variants.v8 && {
            xs: "unset",
            sm: "unset",
            md: "465px"
          })
        },
        mt: {
          ...(card?.variant === variants.v7 && {
            xs: 2,
            sm: 4,
            md: 5
          })
        },
        display: {
          md:
            isTwoUp &&
            card?.ctaAlignment?.toLowerCase() === "horizontal" &&
            "flex"
        },
        ...(hideXS && {
          display: {
            md: "block",
            xs: "none"
          }
        }),
        ...(isTangerineV15 && {
          mt: "12px",
          width: {
 xs: "100%",
sm: "100%"
},
          display: "flex",
          flexDirection: {
 xs: "column",
sm: "row"
},
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: {
            xs: "center",
            sm: fwContentAlignment === "center" ? "center" : "flex-start",
            md: fwContentAlignment === "center" ? "center" : "flex-start"
          }
        })
      }}
    >
      {(card?.cta?.label || card?.cta?.imageUrl) && (
        <DtvBox
          className={`${id}-cta1`}
          sx={{
            display: {
              xs: "flex",
              sm:
                isv3V4TwoUp ||
                ((card?.variant === variants.v3 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v8 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                  card?.optionalCTA &&
                  !isTwoUp) ||
                (isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal") ?
                  "inline-block" :
                  isTwoUp ?
                  "flex" :
                  "flex",
              xl:
                isv3V4TwoUp ||
                ((card?.variant === variants.v3 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v8 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                  card?.optionalCTA &&
                  !isTwoUp) ||
                (isTwoUp &&
                  card?.ctaAlignment?.toLowerCase() === "horizontal") ||
                isTwoUp ?
                  "inline-block" :
                  "flex"
            },
            justifyContent: "center",
            ...(card?.cta?.imageUrl && {
              display: {
                xs: "flex",
                sm: "inline-block"
              }
            }),
            ...(isTangerineV15 && !isTangerineV15FullwidthImage && {
              flex: "0 0 auto"
            })
          }}
        >
          <Button
            aria-label={card?.cta?.accessibility || card?.cta?.label}
            buttontype={card?.cta?.buttontype || card?.cta?.buttonType || "primary"}
            id={`card-cta-${id}-${index}`}
            mode={card?.cta?.mode || card?.mode || fusionBtnMode || "light"}
            size={card?.cta?.size || "medium"}
            {...((({ targeturl, target, accessibility, analytics, buttonType, label, ariaLabel, ...rest }) => rest)(card?.cta || {}))}
            googleanalyticsdata={getAnalyticsAttrs(card?.cta?.label, "body", card?.cta?.targeturl)}
            href={card?.cta?.targeturl}
            isTangerine = {isTangerineV15 ? card?.cta?.isTangerine !== false : card?.cta?.isTangerine === true }
            role="button"
            speciality = {(card?.cta?.variant === 'uxpromoyellow') ? 'solarflare' : card?.cta?.speciality  ? card?.cta?.speciality :  undefined }
            target={card?.cta?.target || "_self"}
            sx={{
              display:
                (card?.variant === variants.v3 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v8 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                card?.optionalCTA &&
                !isTwoUp ?
                  "inline-flex" :
                  isTwoUp ?
                  "block" :
                  isTangerineV14 ?
                  "inline-flex" :
                  "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              verticalAlign: "baseline",
              textAlign: "center",
              marginTop: {
                xs: "32px",
                sm: card?.variant === variants.v5 ? "40px" : "32px",
                md: "40px",
                ...(card?.variant === variants.v7 && {
                  xs: 2,
                  sm: 4,
                  md: 5
                }),
                ...(card?.variant === variants.v8 && {
                  xs: 2,
                  sm: 4,
                  md: 8
                })
              },
              ...(card?.variant === variants.v8 && { width: "222px" }),
              marginBottom: {
                xs: card?.optionalCTA ? "0px" : "20px",
                sm: card?.optionalCTA ?
                  "0px" :
                  card?.variant === variants.v5 ?
                  "24px" :
                  "32px",
                md: "0px"
              },
              mr: {
                xs: isTwoUp ? "0px" : "10px",
                sm:
                  isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                    "5px" :
                    isTwoUp || isOneUpBullet ?
                    "0px" :
                    card?.variant === variants.v8 ?
                    "8px" :
                    "10px",
                xl: "10px",
                ...(card?.optionalCTA?.imageUrl && {
                  xs: "0px",
                  sm: "16px"
                }),
                ...(card?.variant === variants.v7 && {
                  xs: 2,
                  sm: 6,
                  xl: 2
                }),
                ...(card?.variant === variants.v8 && {
                  xs: 0,
                  sm: 5.5,
                  md: 4,
                  xl: 4
                })
              },
              ml: {
                xs: (isTwoUp || isTangerineV14 ) ? "0px" : "10px",
                sm:
                  isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                    "5px" :
                    isTwoUp || isOneUpBullet || isTangerineV14 ?
                    "0px" :
                    "10px",
                xl: (isOneUpBullet || isTangerineV14 ) ? "0px" : "10px",
                ...(card?.cta?.imageUrl && {
                  xs: "0px"
                }),
                ...((card?.variant === variants.v7 ||
                  card?.variant === variants.v8) && {
                  xs: 0,
                  sm: 0,
                  xl: 0
                })
              },

              ...(card?.cta?.imageUrl && {
                width: { xs: "auto" }
              }),
              ...((card?.variant === variants.v2 &&  card?.optionalCTA?.imageUrl) && {
                 marginTop: {
 sm: '32px',
md: '32px'
},
                 marginLeft: {
 xs: '0px',
sm: '16px'
},
                 marginRight: {
 xs: '0px',
sm: '10px'
}

              }),
              ...(card?.variant === variants.v11 && {
                margin: {
                  xs: "16px 0 0 0",
                  sm: "16px 0 0 0",
                  md: "32px 0 0 0"
                }
              }),
              ...(isTangerineV14 && {
                backgroundColor: "#006DFF",
                color: "#ffffff",
                width: {
                  xs: "100%",
                  sm: "200px",
                  md: "200px",
                  lg: "200px",
                  xl: "200px"
                }
               // minWidth: "240px"
              }),
              ...(isTangerineV15 && {
                ...(card?.cta?.backgroundColor ?
                  { backgroundColor: card?.cta?.backgroundColor } :
                  {}),
                ...(card?.cta?.color && { color: card?.cta?.color }),
                ...(card?.cta?.borderColor && { borderColor: card?.cta?.borderColor }),
                ...(card?.cta?.border !== undefined && { border: card?.cta?.border }),
                height: TANGERINE_V15_CTA_HEIGHT,
                ...(card?.cta?.hover && card?.cta?.hover?.disabled !== true && {
                  '&:hover': { ...card?.cta?.hover },
                  '&:focus': { ...card?.cta?.hover },
                  '&:active': { ...card?.cta?.hover }
                }),
                fontWeight: 500,
                fontSize: {
                  xs: "16px",
                  sm: "16px",
                  md: "16px"
                },
                display: 'flex',
                lineHeight: '1.3em',
                width: '100%',
                minWidth: "120px",
                px: "16px",
                py: "0px",
                marginTop: '0px',
                marginBottom: '0px',
                ml: '0px',
                mr: '0px',
                height: TANGERINE_V15_CTA_HEIGHT,
                justifyContent: "center",
                alignItems: "center"
              })
            }}
          >
            {card?.cta?.label || card?.cta?.ariaLabel}
          </Button>
        </DtvBox>
      )}

      {(((card?.variant === variants.v3 || isTangerineV15 ||
        (isTwoUp && card?.variant === variants.v4) ||
        card?.variant === variants.v10 ||
        card?.variant === variants.v7 ||
        card?.variant === variants.v8 ||
        card?.variant === variants.v9 ||
        card?.variant === variants.v11 ||
        card?.variant === variants.v12) &&
        card?.optionalCTA?.label) ||
        card?.optionalCTA?.imageUrl) && (
        <DtvBox
          id={`${id}-cta2`}
          sx={{
            display: {
              xs: "flex",
              sm:
                isv3V4TwoUp ||
                ((card?.variant === variants.v3 ||
                  card?.variant === variants.v4 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                  card?.optionalCTA &&
                  !isTwoUp) ||
                (isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal") ?
                  "inline-block" :
                  isTwoUp ?
                  "flex" :
                  "flex",
              xl:
                isv3V4TwoUp ||
                ((card?.variant === variants.v3 ||
                  card?.variant === variants.v4 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                  card?.optionalCTA &&
                  !isTwoUp) ||
                (isTwoUp &&
                  card?.ctaAlignment?.toLowerCase() === "horizontal") ||
                isTwoUp ?
                  "inline-block" :
                  "flex",
              ...(card?.variant === variants.v8 && {
                sm: "inline-block",
                xl: "inline-block"
              })
            },
            justifyContent: card?.variant === variants.v7 ? "unset" : "center",
            ...(card?.optionalCTA?.imageUrl && {
              display: {
                xs: "flex",
                sm: "inline-block"
              },
              justifyContent: "center"
            }),
            marginLeft: isv3V4TwoUp ? { sm: "32px" } : "auto",
            ...(isTangerineV15 && {
              flex: "0 0 auto",
              marginLeft: '0px'
            })
          }}
        >
          <Button
            aria-label={card?.optionalCTA?.accessibility || card?.optionalCTA?.ariaLabel || card?.optionalCTA?.label}
            buttontype={card?.optionalCTA?.buttontype || card?.optionalCTA?.buttonType || "secondary"}
            id={`card-secondaryCta-${id}-${index}`}
            mode={card?.optionalCTA?.mode || card?.mode || fusionBtnMode || "light"}
            size={card?.optionalCTA?.size || "medium"}
            {...((({ targeturl, target, accessibility, analytics, buttonType, label, ariaLabel, ...rest }) => rest)(card?.optionalCTA || {}))}
            googleanalyticsdata={getAnalyticsAttrs(card?.optionalCTA?.label, "body", card?.optionalCTA?.targeturl)}
            href={card?.optionalCTA?.targeturl}
            isTangerine = { isTangerineV15 ? card?.optionalCTA?.isTangerine !== false : card?.optionalCTA?.isTangerine === true }
            role="button"
            speciality = {(card?.optionalCTA?.variant === 'uxpromoyellow') ? 'solarflare' : card?.optionalCTA?.speciality  ? card?.optionalCTA?.speciality :  undefined }
            target={card?.optionalCTA?.target || "_self"}
            sx={{
              display:
                (card?.variant === variants.v3 ||
                  card?.variant === variants.v4 ||
                  card?.variant === variants.v7 ||
                  card?.variant === variants.v8 ||
                  card?.variant === variants.v9 ||
                  card?.variant === variants.v11 ||
                  card?.variant === variants.v12 ||
                  isTangerineV15) &&
                card?.optionalCTA &&
                !isTwoUp ? "inline-flex" :
                  // ? shouldStackTangerineV15Ctas ? "flex" : "inline-block"
                  isTwoUp ?
                  "block" :
                  "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              verticalAlign: "baseline",
              ...(card?.variant === variants.v8 && { width: "222px" }),
              mt: {
                xs: "16px",
                sm: isTwoUp ? "16px" : "32px",
                md: !isTwoUp ?
                  "40px" :
                  isTwoUp &&
                    card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                  "40px" :
                  "16px",
                sm: isTwoUp ? "16px" : "32px",
                md: !isTwoUp ?
                  "40px" :
                  isTwoUp &&
                    card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                  "40px" :
                  "16px",
                ...(card?.variant === variants.v7 && {
                  xs: 2,
                  sm: 4,
                  md: 5
                }),
                ...(card?.variant === variants.v8 && {
                  xs: 4,
                  sm: 4,
                  md: 8
                })
              },
              mr: {
                xs: isTwoUp ? "0px" : "10px",
                sm:
                  isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                    "5px" :
                    isTwoUp ?
                    "0px" :
                    "10px",
                xl: "10px",
                ...(card?.optionalCTA?.imageUrl && {
                  xs: "0px"
                }),
                ...((card?.variant === variants.v7 ||
                  card?.variant === variants.v8) && {
                  xs: 0,
                  sm: 0,
                  xl: 0
                })
              },
              ml: {
                xs: isTwoUp ? "0px" : "10px",
                sm:
                  isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                    "5px" :
                    isTwoUp ?
                    "0px" :
                    "10px",
                xl: "10px",
                ...(card?.optionalCTA?.imageUrl && {
                  xs: "0px",
                  sm: "16px"
                }),
                ...((card?.variant === variants.v7 ||
                  card?.variant === variants.v8) && {
                  xs: 0,
                  sm: 0,
                  xl: 0
                })
              },
              mb: {
                md:
                  isTwoUp && card?.ctaAlignment?.toLowerCase() === "horizontal" ?
                    "0px" :
                    isTwoUp ?
                    "40px" :
                    "0px"
              },
              ...(card?.optionalCTA?.imageUrl && {
                width: { xs: "auto" }
              }),
                ...((card?.variant === variants.v2 &&  card?.optionalCTA?.imageUrl) && {
                  marginTop: {
 sm: '16px',
md: '32px'
},
                  marginLeft: {
 xs: '0px',
sm: '16px'
},
                  marginRight: {
 xs: '0px',
sm: '10px'
}
              }),
              ...(isTangerineV15 && {
                width: '100%',
                display: 'flex',
                minWidth: "120px",
                fontWeight: 500,
                lineHeight: '1.3em',
                fontSize: {
                  xs: "16px",
                  sm: "16px",
                  md: "16px"
                },
                mt: '0px',
                mb: '0px',
                ml: '0px',
                mr: '0px',
                px: "16px",
                py: "0px",
                border: '1.5px solid',
                height: TANGERINE_V15_CTA_HEIGHT,
                ...(card?.optionalCTA?.color && {
                  color: card?.optionalCTA?.color
                }),

                ...(card?.optionalCTA?.border !== undefined && {
                  border: card?.optionalCTA?.border
                }),
                '&::before': {
                  border: card?.optionalCTA?.border ? 'none' : undefined
                },
                ...(card?.optionalCTA?.backgroundColor ?
                  { backgroundColor: card?.optionalCTA?.backgroundColor } :
                  {}),
                ...((card?.optionalCTA?.hover && card?.optionalCTA?.hover?.disabled !== true && card?.optionalCTA?.backgroundColor) && {
                  '&:hover': { ...card?.optionalCTA?.hover },
                  '&:focus': { ...card?.optionalCTA?.hover },
                  '&:active': { ...card?.optionalCTA?.hover }
                }),
                justifyContent: "center",
                alignItems: "center"
              })
            }}
          >{card?.optionalCTA?.label || card?.optionalCTA?.ariaLabel}</Button>
        </DtvBox>
      )}
    </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay error={error} />;
  }
};

export function DtvContentCards(props: DtvContentCardsProps) {
  try {
    const [isCountDownTimerExpired, setIsCountDownTimerExpired] =
    React.useState(false);
    const isDesktop = useMediaQuery("(min-width:1100px)and (max-width:1250px)");
    const isTangerineV15Mobile = useMediaQuery("(max-width:600px)", {
      noSsr: true
    });
    const isOneUpBullet = props?.id === "contentCard-v10";
    const FeaturedLogos = props => (
      <DtvBox
        id={`feature-logos-v4-${props?.id}`}
        sx={{
          display: "inline-flex",
          width: {
            xs: "100%",
            md: props?.isTwoUp ? "100%" : "55%"
          },
          // float: "right",
          // borderLeft: "1px solid #0a1116",
          bottom: {
            xs: "2%",
            lg: props?.isTwoUp ? "0%" : "2%"
          },
          position: {
            xs: "absolute",
            md: props?.isTwoUp ? "absolute" : "relative"
          },
          alignItems: "center",
          justifyContent: "center",
          zIndex: 3,
          padding: {
            xs: "20px",
            sm: "40px",
            md: props?.isTwoUp ? "0px" : "unset",
            lg: props?.isTwoUp ? "40px" : "0px",
            xl: props?.isTwoUp ? "80px" : "0px"
          }
        }}
      >
        {props?.logos?.map((logo, index) => (
          <DtvBox
            alt={logo?.imageAlt}
            component="img"
            id={`horizontal-imageInDesktop-${props?.id}-${index}`}
            key={index}
            loading={props?.aboveTheFold ? "eager" : "lazy"}
            src={logo?.imageUrl}
            sx={{
              height: {
                xs: "40px",
                sm: "60px",
                md: "60px"
              },
              width: {
                xs: "40px",
                sm: "60px",
                md: "60px"
              },
              mr: {
                xs: "12px",
                sm: "20px",
                md: "20px"
              }
            }}
          />
        ))}
      </DtvBox>
    );
    const Bullets = props => {
      try{
        return (
        <DtvBox
          id={`bullets-v5-${props?.id}`}
          sx={{
            left: "0px",
            display: {
              xs: "inline",
              sm: isOneUpBullet ? "block" : "inline-flex"
            },
            width: "100%",
            // float: "right",
            bottom: "0%", // { xs: "0%", md: props.isTwoUp ? "2%" : "0%" },
            position: {
              xs: isOneUpBullet ? " relative" : "absolute",
              md: props?.isTwoUp ? "absolute" : "relative"
            },
            // alignItems: "center",
            justifyContent: "center",
            zIndex: 3,
            // pl: "40px",
            // pt: {md: "64px"},
            // paddingBottom: {
            //   xs: "0px",
            //   md: props.isTwoUp ? "40px" : "unset",
            //   lg: "0px",
            // },

            padding: {
              xs: "40px 20px 20px 20px",
              sm: "40px",
              md: props?.isTwoUp ? "40px" : "0px",
              xl: props?.isTwoUp ? "80px" : "0px"
            },
            ...(isOneUpBullet && {
              padding: {
 xs: "0px 0px 0px 12px",
sm: "0px 0px  0px 24px"
}
            }),
            opacity: "90%"
          }}
        >
          {props?.bullets?.map((bullet, index) => (
              <DtvText
                aria-label={bullet?.bulletText?.content}
                component={props?.bulletText?.component || "div"}
                content={bullet?.bulletText?.content}
                id={`bullets-copy-${props?.id}-${index}`}
                key={index}
                variant="body2"
                cta={{
                  label: bullet?.bulletText?.cta?.label,
                  legalUrl: bullet?.bulletText?.cta?.legalUrl,
                  position: bullet?.bulletText?.cta?.position
                }}
                sx={{
                  maxWidth: {
                    xs: "100%",
                    sm:
                      (props?.isBulletFullwidth &&
                        props?.isBulletFullwidth?.toLowerCase() === "yes") ||
                      isOneUpBullet ?
                        "100%" :
                        "140px",
                    lg:
                      (props?.isBulletFullwidth &&
                        props?.isBulletFullwidth?.toLowerCase() === "yes") ||
                      isOneUpBullet ?
                        "100%" :
                        "150px",
                    xl:
                      (props?.isBulletFullwidth &&
                        props?.isBulletFullwidth?.toLowerCase() === "yes") ||
                      isOneUpBullet ?
                        "100%" :
                        props?.isTwoUp ?
                        "180px" :
                        "190px"
                  },
                  // whiteSpace: "pre-wrap",
                  pr: isOneUpBullet ?
                    "0px" :
                    {
                        xs: "0px",
                        sm: !props?.isTwoUp ? "40px" : "0px",
                        md: !props?.isTwoUp ? "15px" : "0px",
                        lg: !props?.isTwoUp ? "20px" : "0px",
                        xl: !props?.isTwoUp ? "20px" : "0px"
                      },

                  pb: {
                    xs: "12px",
                    sm: isOneUpBullet ? "12px" : "0px",
                    lg: isOneUpBullet ? "12px" : "0px"
                  },
                  ":not(:first-child)": {
                    pl: {
                      xs: "0px",
                      sm: props?.isTwoUp ? "40px" : "0px",
                      md: props?.isTwoUp ? "15px" : "0px",
                      lg: props?.isTwoUp ? "20px" : "0px",
                      xl: props?.isTwoUp ? "36px" : "0px"
                    }
                  },
                  m: { xs: "0px" },
                  flex: 1,
                  textAlign: isOneUpBullet ? "start" : "center",
                  justifyContent: "center",
                  display: isOneUpBullet ? "list-item" : "block",
                  ":nth-child(3)": {
                    pb: 0
                  }
                }}
                tooltip={{
                  content: bullet?.bulletText?.tooltip?.content,
                  position: bullet?.bulletText?.tooltip?.position,
                  mode: bullet?.bulletText?.tooltip?.mode
                }}
              />
            ))}
        </DtvBox>
        );
      } catch (error) {
        return <ErrorDisplay error={error} />;
      }
    };
    const handleLinkClick = e => {
      if (props.analytics) {
        const _data: LinkAnalytics = {
          ...props?.analytics,
          linkDestination: e.currentTarget.href,
          linkName: e.currentTarget.innerText,
          linkPosition: LINK_POSITION_BODY
        };
      }
    };

    const ServiceCard = props => {
      try{
        return (
        <>
          {props?.cards?.map((card, index) => {
            const defaultBgColor =
              card?.variant === variants.v3 || card?.variant === variants.v4 ?
                `jet.main` :
                card?.variant === variants.v5 ?
                `lapis.main` :
                "";
            const bgColorArray =
              card?.backgroundColor && card?.backgroundColor !== "" ?
                card?.backgroundColor?.split(".") :
                defaultBgColor.split(".");
            const bgColor = DtvTheme.palette[bgColorArray[0]][bgColorArray[1]];
            const isThreeUp = props?.cards?.length === 3;
            const sxImageUrl = (
              card?.variant === variants.v5 && card?.image?.optionalImageUrl ?
                card?.image?.optionalImageUrl :
                card?.image?.imageUrl
            )?.trim();
            const mdImageUrl = card?.image?.imgDesktop1UpOnlyUrl?.trim();
            const lgImageUrl = card?.image?.imgDesktop1UpOnlyUrl;

            return (
              <DtvGrid
                item
                key={index}
                sm={4}
                title={card?.headline?.content}
                xs={12}
                sx={{
                  cursor: "pointer",
                  position: "relative",
                  pt: "20px",
                  ":nth-child(3)": {
                    pl: {
                      xs: "0px",
                      sm: "13.333px"
                    }
                  },
                  ":nth-child(1)": {
                    pr: {
                      xs: "0px",
                      sm: "13.333px"
                    }
                  },
                  ":nth-child(2)": {
                    pl: {
                      xs: "0px",
                      sm: "6.663px"
                    },
                    pr: {
                      xs: "0px",
                      sm: "6.663px"
                    }
                  }
                }}
                onClick={() => {
                  window.open(`${card?.image?.imageTargetUrl}`, "_self");
                }}
              >
                <DtvBox
                  sx={{
                    borderRadius: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "center",
                    color: "#FAFAFA",
                    backgroundColor:
                      card?.backgroundColor && card?.backgroundColor !== "" ?
                        `${card?.backgroundColor}` :
                        `${defaultBgColor}`,
                    aspectRatio: "1/0.8",
                    position: "relative"
                  }}
                >
                  <DtvBox
                    sx={{
                      borderRadius: "10px",
                      height: "100%",
                      backgroundSize: "100% auto",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom center",
                      position: "absolute",
                      left: {
                        xs: "0px",
                        md: isThreeUp ? "0px" : "unset"
                      },
                      right: { md: "0px" },
                      top: "0px",
                      zIndex: 1,
                      alignItems: "center",
                      width: "100%"
                    }}
                  >
                    <picture>
                      <source
                        media={`(min-width: ${DtvTheme.breakpoints.values.md}px)`}
                        srcSet={`${lgImageUrl}?noretina=true 1x, ${lgImageUrl} 2x`}
                      />
                      <source
                        media={`(min-width: ${DtvTheme.breakpoints.values.sm}px)`}
                        srcSet={`${mdImageUrl}?imwidth=900&noretina=true 1x, ${mdImageUrl}?imwidth=900 2x`}
                      />
                      <img
                        alt={card?.image?.imageAlt || ""}
                        id={`card-image-1up-${props?.id}-${index}`}
                        loading={ props?.aboveTheFold ? "eager" : "lazy" }
                        srcSet={`${sxImageUrl}?imwidth=600&noretina=true 1x, ${sxImageUrl}?imwidth=600 2x`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "10px"
                        }}
                      />
                    </picture>
                  </DtvBox>
                  {card?.variant === variants.v6 && (
                    <DtvBox
                      aria-hidden={true}
                      sx={{
                        borderRadius: "10px",
                        position: "absolute",
                        backgroundImage: {
                          xs: `linear-gradient(${
                            card?.variant === variants.v6 ?
                              isThreeUp ?
                                "180deg" :
                                "360deg" :
                              "180deg"
                          },  ${bgColor} 25%, ${bgColor} 25%, transparent 35%)`,
                          md: `linear-gradient(${
                            isThreeUp ? "180deg" : "90deg"
                          }, ${bgColor} 25%, ${bgColor} 25%, transparent 35%)`
                        },
                        zIndex: 3,
                        height: "100%",
                        left: "0px",
                        top: "0px",
                        width: "100%",
                        mixBlendMode: "initial"
                      }}
                    />
                  )}
                  <DtvBox
                    sx={{
                      borderRadius: "10px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "auto",
                      justifyContent: "center",
                      position: "absolute",
                      zIndex: 3,
                      textAlign: "center",
                      color: "#FAFAFA",
                      width: "100%"
                    }}
                  >
                    <DtvText
                      aria-label={card?.headline?.content}
                      component={card?.headline?.component || "h2"}
                      content={card?.headline?.content}
                      cta={card?.headline?.cta}
                      id="card-headline"
                      variant="subhead2"
                      sx={{
                        marginBottom: "60%",
                        maxWidth: {
                          xs:
                            card?.isHeadlineFullwidth &&
                            card?.isHeadlineFullwidth?.toLowerCase() === "yes" ?
                              "100%" :
                              "240px",
                          sm:
                            card?.isHeadlineFullwidth &&
                            card?.isHeadlineFullwidth?.toLowerCase() === "yes" ?
                              "100%" :
                              "450px",
                          xl:
                            card?.isHeadlineFullwidth &&
                            card?.isHeadlineFullwidth?.toLowerCase() === "yes" ?
                              "100%" :
                              "610px"
                        }
                      }}
                      tooltip={{
                        content: card?.headline?.tooltip?.content,
                        position: card?.headline?.tooltip?.position,
                        mode: card?.headline?.tooltip?.mode
                      }}
                    />
                  </DtvBox>
                </DtvBox>
              </DtvGrid>
            );
          })}
        </>
        );
      } catch (error) {
        return <ErrorDisplay error={error} />;
      }
    };

    const cardVariant =
      props?.cards?.length === 3 && props?.cards?.[0]?.variant === variants.v6 ?
        variants.v6 :
        props?.cards?.[0]?.variant === variants.v7 ?
          variants.v7 :
          props?.cards?.[0]?.variant === variants.v13 ?
            variants.v13 :
            "";
    return (
      <DtvBox
        sx={{
          margin: {
            xs:
              props?.isFullWidth && props?.isFullWidth?.toLowerCase() === "yes" ?
                "0px" :
                cardVariant === variants.v13 ?
                "0 20px 0 20px" :
                "0 20px 0 20px",
            sm:
              props?.isFullWidth && props?.isFullWidth?.toLowerCase() === "yes" ?
                "0px" :
                cardVariant === variants.v13 ?
                "0 32px 0 0px" :
                "0 32px 0 32px",
            md:
              props?.isFullWidth && props?.isFullWidth?.toLowerCase() === "yes" ?
                "0px" :
                cardVariant === variants.v13 ?
                "0 100px 0 0px" :
                "0 100px 0 100px",
            lg:
              props?.isFullWidth && props?.isFullWidth?.toLowerCase() === "yes" ?
                "0px" :
                cardVariant === variants.v13 ?
                "0 140px 0 0px" :
                "0 140px 0 140px",
            xl:
              props?.isFullWidth && props?.isFullWidth?.toLowerCase() === "yes" ?
                "0px" :
                cardVariant === variants.v13 ?
                "0 180px 0 0px" :
                "0 180px 0 180px"
          }
        }}
      >
        <DtvGrid
          container
          direction="row"
          spacing={0}
          sx={{
 display: "inline-flex",
overFlow: "hidden"
}}
        >
          {cardVariant === variants.v6 ? (
            <>
              <ServiceCard {...props} />{" "}
            </>
          ) : (
            <>
              {/* eslint-disable-next-line complexity */}
              {props?.cards?.map((card, index) => {
                const cardVariant = card?.variant;
                const isTangerineV14 = cardVariant === variants.v14;
                const isTangerineV15 = cardVariant === variants.v15 || cardVariant === "CC-TangerineEnhancedLeft";
                const isTangerineV15FullwidthImage =
                  isTangerineV15 &&
                  card?.enableFullWidthBgImg === true;
                const contentAlignment = isTangerineV15FullwidthImage ?
                  (card?.contentOrder?.content === 0 ? "center" : card?.contentOrder?.content === 2 ? "right" : "left") :
                  "center";
                // Mobile: content overlays the image; justifyContent shifts it top/bottom/center
                const v15FwMobileJustify =
                  contentAlignment === "left" ? "flex-start" :
                  contentAlignment === "right" ? "flex-end" :
                  "center";
                  // Temporary workaround until the issue is fixed in the CMS or at the Fusion button level
                  const fusionBtnMode = (['jet.main', 'lapis.main', 'black.main'].includes(card.backgroundColor)) ? 'dark' : undefined;
                const defaultBgColor =
                  card?.variant === variants.v3 ||
                  card?.variant === variants.v10 ||
                  card?.variant === variants.v4 ?
                    `jet.main` :
                    card?.variant === variants.v5 ?
                    `lapis.main` :
                    "";
                const bgColorArray =
                  card?.backgroundColor &&
                  card?.backgroundColor !== "" &&
                  card?.backgroundColor !== "none" ?
                    card?.backgroundColor.split(".") :
                    defaultBgColor.split(".");
                const bgColor =
                  card?.backgroundColor !== "none" ?
                    DtvTheme?.palette?.[bgColorArray?.[0]]?.[bgColorArray?.[1]] :
                    "none";
                const isTwoUp = props?.cards?.length > 1;
                const sxImageUrl = (
                  (card?.variant === variants.v5 || isTangerineV15 || isTangerineV15FullwidthImage) && card?.image?.optionalImageUrl ?
                    card?.image?.optionalImageUrl :
                    card?.image?.imageUrl
                )?.trim();
                const mdImageUrl =
                  (isTangerineV14 || isTangerineV15 || isTangerineV15FullwidthImage) ?
                    card?.image?.tabletImgUrl?.trim() :
                    card?.image?.imageUrl?.trim();
                const lgImageUrl = (
                  !isTwoUp ?
                    card?.image?.imgDesktop1UpOnlyUrl :
                    card?.image?.imageUrl
                )?.trim();
                const tangerineV15ImageOrder = card?.contentOrder?.image ?? 2;
                const isTangerineV15ImageFirst = tangerineV15ImageOrder === 1;

                if (isCountDownTimerExpired) {
                  // eslint-disable-next-line no-param-reassign
                  card = {
                    ...card,
                    ...card?.overrideExpiredCountdownTimerContent
                  };
                }

                const isv4TwoUp = isTwoUp && card?.variant === variants.v4;
                const isv3V4TwoUp =
                  isTwoUp &&
                  (card?.variant === variants.v3 ||
                    card?.variant === variants.v4);
                const getCardHeight = (isTwoUp, card) => {
                  /* start-copilot */
                  if (isTangerineV15 || isTangerineV15FullwidthImage) {
                    return {
                      xs: card?.xs?.maxHeight ?? "auto",
                      sm: card?.sm?.maxHeight ?? "auto",
                      md: card?.md?.maxHeight ?? "auto",
                      lg: card?.lg?.maxHeight ?? "auto",
                      xl: card?.xl?.maxHeight ?? "auto"
                    };
                  }
                  /* end-copilot */
                  return {
                    xs:
                      // (isTwoUp && (card?.variant === variants.v3 || (card?.variant === variants.v4 && card?.featuredLogos && card?.featuredLogos?.length === 0) )) ? "auto" :
                      card?.variant === variants.v1 ||
                      card?.variant === variants.v2 ||
                      card?.variant === variants.v9 ?
                        card?.v2Styles?.height?.xs || "566px" :
                        card?.variant === variants.v10 ||
                          card?.variant === variants.v11 ||
                          card?.variant === variants.v12 ?
                        card?.xs?.maxHeight  :
                          isTangerineV14 ?
                          card?.xs?.maxHeight ||  "540px" :
                        "550px",
                    sm:
                      isTwoUp &&
                      (card?.variant === variants.v3 ||
                        (card?.variant === variants.v4 &&
                          card?.featuredLogos &&
                          card?.featuredLogos?.length === 0)) ?
                        (card?.customHeightFor2up || "700px") :
                        card?.variant === variants.v10 ||
                          card?.variant === variants.v11 ||
                          card?.variant === variants.v12 ?
                          card?.sm?.maxHeight : isTangerineV14 ?
                          card?.sm?.maxHeight || "359px" :
                        card?.v2Styles?.height?.sm || "712px",
                    md: isTwoUp ?
                      isv3V4TwoUp ?
                        "auto" :
                        "720px" :
                      card?.variant === variants.v7 ?
                      "378px" :
                        isTangerineV14 ?
                        card?.md?.maxHeight || "299px" :
                      card?.v2Styles?.height?.md || "480px",
                    lg: isTwoUp ?
                      (isv3V4TwoUp ? "auto" : "720px") :
                          isTangerineV14 ?
                          card?.lg?.maxHeight || "299px" :
                        card?.v2Styles?.height?.lg || "480px",
                    xl: isTwoUp ?
                      isv3V4TwoUp ?
                        "auto" :
                        "900px" :
                      card?.variant === variants.v7 ?
                      card?.v2Styles?.height?.xl || "480px" :
                        isTangerineV14 ?
                        card?.xl?.maxHeight || "299px" :
                      "600px"

                  };
                };

                if (card?.variant === variants.v13) {
                  const defaultBgColor = "#F4F4F4";
                  const bgColor = card?.backgroundColor || defaultBgColor;
                  const sxImageUrl = card?.image?.imageUrl?.trim();

                  const handleCardClick = () => {
                    const displayedText = card?.headline?.content || "";
                    const destination =
                      card?.cta?.targeturl || card?.image?.imageTargetUrl || window.location.href;
                    fireCustomLinkClickGA({
                      linkName: `gemini card | ${String(displayedText).toLowerCase()}`,
                      linkPosition: "globalnav_panel_search",
                      linkDestination: constructFullUrl(destination)
                    });
                  };

                  return (
                    <DtvGrid
                      item
                      key={index}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        position: "relative",
                        p: 0,
                        display: 'flex',
                        justifyContent: {
 xs: 'center',
sm: 'flex-start'
}
                      }}
                    >
                      <DtvBox
                        sx={{
                          backgroundColor: bgColor,
                          borderRadius: {
 xs: "8px",
sm: "12px"
},
                          border: "1px solid #E0E0E0",
                          overflow: "hidden",
                          height: {
 xs: "470px",
sm: "218px"
},
                          width: {
 xs: "335px",
sm: "700px",
md: "700px",
lg: "700px",
xl: "700px"
},
                          minWidth: {
 xs: "335px",
sm: "700px",
md: "700px",
lg: "700px",
xl: "700px"
},

                          display: "flex",
                          flexDirection: {
 xs: "column",
sm: "row"
},
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.15)"
                          }
                        }}
                        onClick={handleCardClick}
                      >
                        {/* Product Image */}
                        <DtvBox
                          sx={{
                            position: "relative",
                            width: {
 xs: "100%",
sm: "350px"
},
                            height: {
 xs: "211px",
sm: "218px"
},
                            minWidth: {
 xs: "auto",
sm: "350px"
},
                            maxWidth: {
 xs: "100%",
sm: "350px"
},
                            overflow: "hidden",
                            flexShrink: 0
                          }}
                        >
                          <img
                            alt={card?.image?.imageAlt || "Product image"}
                            id={`product-card-horizontal-image-${props?.id}-${index}`}
                            loading={props?.aboveTheFold ? "eager" : "lazy"}
                            src={sxImageUrl}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: {
 xs: "8px 8px 0 0",
sm: "12px 0 0 12px"
}
                            }}
                          />
                        </DtvBox>

                        {/* Content Section */}
                        <DtvBox
                          sx={{
                            px: "20px",
                            pt: {
 xs: "20px",
sm: "20px"
},
                            pb: {
 xs: "0px",
sm: "20px"
},
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            minHeight: {
 xs: "230px",
sm: "218px"
},
                            maxHeight: {
 xs: "none",
sm: "none"
},
                            overflow: {
 xs: "visible",
sm: "visible"
},
                            position: "relative",
                            backgroundColor: "#F4F4F4"
                          }}
                        >
                          {/* Product Title */}
                          <DtvText
                            aria-label={card?.headline?.content}
                            component="h3"
                            content={card?.headline?.content}
                            id={`product-card-horizontal-title-${props?.id}-${index}`}
                            variant="subhead2"
                            sx={{
                              color: "#102641",
                              mb: "5px",
                              fontWeight: 500,
                              lineHeight: "130%",
                              letterSpacing: "-0.48px",
                              fontSize: "24px"
                            }}
                          />

                          {/* Bullet Points */}
                          {card?.bullets && (
                            <DtvBox sx={{
 mb: {
 xs: "5px",
sm: "5px"
}
}}>
                              {card.bullets.slice(0, 3).map((bullet, bulletIndex) => (
                                <DtvBox
                                  key={bulletIndex}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: "8px",
                                    gap: {
 xs: "16px",
sm: "16px",
md: "15px"
}
                                  }}
                                >
                                  <svg
                                    fill="none"
                                    height="24"
                                    width="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
 marginRight: {
 xs: '6px',
sm: '8px'
},
flexShrink: 0
}}
                                  >
                                    <path
                                      d="M19.1579 7.01224L11.7883 18.6514C11.5181 19.0818 11.0655 19.3334 10.5724 19.3334C10.1401 19.3334 9.72809 19.1348 9.44438 18.7839L4.91186 13.196C4.5471 12.7524 4.59438 12.0969 5.01994 11.7063C5.43199 11.3289 6.12774 11.3157 6.54654 11.6931L10.3968 15.0961L17.2935 5.78079C17.638 5.31734 18.3473 5.19155 18.8336 5.50934C19.3403 5.84037 19.4821 6.50245 19.1646 7.00563L19.1579 7.01224Z"
                                      fill="#2E70BD"
                                    />
                                  </svg>
                                  <DtvText
                                    content={bullet.bulletText}
                                    sx={{
                                      color: "#102641",
                                      fontFamily: 'Roboto, sans-serif !important',
                                      fontSize: {
                                        xs: "16px !important",
                                        sm: "14px !important",
                                        md: "14px !important"
                                      },
                                      fontWeight: "400 !important",
                                      lineHeight: "1.3 !important",
                                      margin: "0 !important"
                                    }}
                                  />
                                </DtvBox>
                              ))}
                            </DtvBox>
                          )}

                          {/* Learn More Button */}
                          {card?.cta && (
                            <DtvBox
                              sx={{
                                mt: {
 xs: "0px",
sm: "-8px"
},
                                position: {
 xs: "static",
sm: "static"
},
                                alignSelf: {
 xs: "center",
sm: "flex-start"
}
                              }}
                            >
                              <Button
                                aria-label={card?.cta?.accessibility || card?.cta?.label}
                                buttontype={card?.cta?.buttontype || card?.cta?.buttonType || "tertiary"}
                                googleanalyticsdata={getAnalyticsAttrs(`gemini card | ${String(card?.headline?.content || "").toLowerCase()}`, "globalnav_panel_search", card?.cta?.targeturl || card?.image?.imageTargetUrl || window.location.href)}
                                id={`product-card-horizontal-cta-${props?.id}-${index}`}
                                mode={card?.cta?.mode || fusionBtnMode || "light"}
                                size={card?.cta?.size || "medium"}
                                {...((({ targeturl, target, accessibility, analytics, buttonType, label, ariaLabel, variant, onClick: ctaOnClick, ...rest }) => rest)(card?.cta || {}))}
                                href={card?.cta?.targeturl}
                                isTangerine = {isTangerineV15 ? card?.cta?.isTangerine !== false : card?.cta?.isTangerine === true }
                                speciality = {(card?.cta?.variant === 'uxpromoyellow') ? 'solarflare' : card?.cta?.speciality  ? card?.cta?.speciality :  undefined }
                                target={card?.cta?.target || "_self"}
                                sx={{
                                  backgroundColor: "#102641",
                                  color: "#FFFFFF",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  textTransform: "none",
                                  padding: {
 xs: "0 spacing95",
sm: "0"
},
                                  minWidth: "auto",
                                  borderRadius: "24px",
                                  width: {
 xs: "263px",
sm: "113px"
},
                                  height: {
 xs: "36px",
sm: "31px"
},
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  boxShadow: "0 2px 8px rgba(16, 38, 65, 0.3)",
                                  transition: "all 0.3s ease",
                                  whiteSpace: "nowrap",
                                  "&:hover": {
                                    backgroundColor: "#0A1A2A",
                                    color: "#FFFFFF",
                                    textDecoration: "none",
                                    transform: "translateY(-1px)",
                                    boxShadow: "0 4px 12px rgba(16, 38, 65, 0.4)"
                                  }
                                }}
                                onClick={e => {
                                  if (card?.cta?.onClick) {
                                    card?.cta?.onClick(e);
                                  }
                                }}
                              >
                                {card?.cta?.label || card?.cta?.ariaLabel}
                              </Button>
                            </DtvBox>
                          )}
                        </DtvBox>
                      </DtvBox>
                    </DtvGrid>
                  );
                }

                return (
                  <DtvGrid
                    item
                    key={index}
                    md={isTwoUp ? 6 : 12}
                    xs={12}
                    sx={{
                      position: "relative",
                      pt: {
 xs: "20px",
md: "0px"
},
                      ":nth-of-type(odd)": {
                        pr: {
                          xs: "0px",
                          md: isTwoUp ? "10px" : "0px"
                        }
                      },
                      ":nth-of-type(even)": {
                        pl: {
                          xs: "0px",
                          md: isTwoUp ? "10px" : "0px"
                        }
                      }
                    }}
                  >
                    <DtvBox
                      sx={{
                        borderRadius: "10px",
                        justifyContent:
                          card?.variant === variants.v3 ||
                          card?.variant === variants.v4 ?
                            "flex-start" :
                            "center",
                        alignItems: "center",
                        display: "flex",
                        textAlign:
                          card?.variant === variants.v7 || isTangerineV14 || (isTangerineV15 && !isTangerineV15FullwidthImage) ?
                            "left" :
                            "center",
                        color: "#FAFAFA",
                        backgroundColor:
                          card?.backgroundColor && card?.backgroundColor !== "" ?
                            card?.backgroundColor === "none" ?
                              "" :
                              `${card?.backgroundColor}` :
                            isTangerineV14 || isTangerineV15 ?
                            `${card?.backgroundColor || defaultBgColor}` :
                            `${defaultBgColor}`,

                        height: getCardHeight(isTwoUp, card),
                        position: "relative",
                        minHeight: isv3V4TwoUp ?
                          {
                              xs: "350px",
                              sm: "350px",
                              md: "720px",
                              xl: "900px"
                            } :
                          {},
                        maxHeight: isv3V4TwoUp ?
                          {
                              xs: "600px",
                              sm: "800px",
                              md: "720px",
                              xl: "900px"
                            } :
                          {},
                        ...(isTangerineV14 && {
                          background: {
                            xs: card?.xs?.background,
                            sm: card?.sm?.background,
                            md: card?.md?.background,
                            lg: card?.lg?.background,
                            xl: card?.xl?.background
                          }
                        }),
                        ...(isTangerineV15 &&
                          (isTangerineV15FullwidthImage ?
                            {
                                background: "none",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                  xs: "center",
                                  sm: contentAlignment === 'center' ? 'center' : 'flex-start',
                                  md: contentAlignment === 'center' ? 'center' : 'flex-start'
                                },
                                justifyContent: {
                                  xs: v15FwMobileJustify,
                                  sm: "center",
                                  md: "center"
                                },
                                color: card?.mode === "dark" ? "#FAFAFA" : "#121212",

                                height: {
                                  xs: card?.xs?.maxHeight || "auto",
                                  sm: card?.sm?.maxHeight || "auto",
                                  md: card?.md?.maxHeight || "auto"
                                },
                                position: "relative",
                                overflow: "hidden",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  inset: 0,
                                  background: {
                                    xs: card?.xs?.background,
                                    sm: card?.sm?.background,
                                    md: card?.md?.background,
                                    lg: card?.lg?.background,
                                    xl: card?.xl?.background
                                  },
                                  zIndex: 1,
                                  borderRadius: "10px"
                                }
                              } :
                            {
                                background: {
                                  xs: card?.xs?.background,
                                  sm: card?.sm?.background,
                                  md: card?.md?.background,
                                  lg: card?.lg?.background,
                                  xl: card?.xl?.background
                                },
                                display: "flex",
                                flexDirection: {
                                  xs: "column",
                                  sm: "row"
                                },
                                alignItems: {
                                  xs: "stretch",
                                  sm: "stretch"
                                },
                                justifyContent: {
                                  xs: "flex-start",
                                  sm: "space-between"
                                },
                                gap: {
                                  xs: "8px",
                                  sm: "0px"
                                },
                                color: card?.mode === "dark" ? "#FAFAFA" : "#121212"
                              }))
                      }}
                    >
                      {card?.variant === variants.v4 &&
                        card?.featuredLogos &&
                        card?.featuredLogos?.length > 0 && (
                          <DtvBox
                            id={`${props?.id}-parent-mobile-logo`}
                            sx={{
                              display: {
                                xs: "block",
                                md: isTwoUp ? "block" : "none"
                              }
                            }}
                          >
                            <FeaturedLogos
                              id={`${props?.id}-mobile`}
                              isTwoUp={isTwoUp}
                              lazyLoadImages={!props?.aboveTheFold}
                              logos={card?.featuredLogos}
                            />
                          </DtvBox>
                        )}
                      {card?.variant === variants.v11 && (
                        <DtvBox>
                          {card?.cta?.label && (
                            <DtvBox
                              sx={{
                                display: {
                                  xs: "block",
                                  md: "none"
                                },
                                justifyContent: "center",
                                color:
                                  card?.mode === "dark" ? "#102641" : "#FAFAFA"
                              }}
                            >
                              <DtvBox
                                sx={{
                                  display: "inline",
                                  position: "absolute",
                                  left: "0px",
                                  width: "100%",
                                  bottom: "0%",
                                  justifyContent: "center",
                                  padding: { xs: "16px 22px 40px 22px" },
                                  zIndex: "3",
                                  opacity: "90%"
                                }}
                              >
                                <CtaContainer
                                  analytics={props?.analytics}
                                  card={card}
                                  id={`${props?.id}-v11-cta-container`}
                                  index={index}
                                  isOneUpBullet={isOneUpBullet}
                                  isv3V4TwoUp={isv3V4TwoUp}
                                />

                                <DtvBox
                                  sx={{
                                    margin: "16px 0 0 0"
                                  }}
                                >
                                  <DtvText {...card?.legalText} />
                                </DtvBox>
                              </DtvBox>
                            </DtvBox>
                          )}
                        </DtvBox>
                      )}
                      {card?.variant === variants.v5 &&
                        card?.bullets &&
                        card?.bullets?.length > 0 && (
                          <DtvBox
                            id={`${props?.id}-parent-mobile-bullet`}
                            sx={{
                              display: {
                                xs: "block",
                                sm: "flex",
                                md: isTwoUp ? "block" : "none"
                              },
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <Bullets
                              bullets={card?.bullets}
                              id={`${props?.id}-mobile`}
                              isBulletFullwidth={card?.isBulletFullwidth}
                              isTwoUp={isTwoUp}
                              sx={{
                                display: {
                                  xs: "block",
                                  sm: "flex",
                                  md: isTwoUp ? "block" : "none"
                                },
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            />
                          </DtvBox>
                        )}
                      <DtvBox
                        sx={{
                          // display: "block",
                          borderRadius: "10px",
                          height: {
                            xs: card?.variant === variants.v7 ? "40%" : "100%",
                            sm: card?.variant === variants.v7 ? "70%" : "100%",
                            md: "100%",
                            lg: "100%"
                          },
                          backgroundSize: "100% auto",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "bottom center",
                          position:
                            isTangerineV15 && !isTangerineV15FullwidthImage ?
                              "relative" :
                              card?.variant === variants.v3 ?
                              {
                                  xs: "absolute",
                                  sm: "relative",
                                  md: "absolute"
                                } :
                              "absolute",
                          left:
                            isTangerineV15 && !isTangerineV15FullwidthImage ?
                              "unset" :
                              !isTwoUp &&
                                card?.flipDirection &&
                                card?.flipDirection?.toLowerCase() === "yes" ?
                              "0px" :
                              {
                                  xs: "0px",
                                  sm: (isTangerineV14 || isTangerineV15) && "unset",
                                  md: isTwoUp ?
                                    "0px" :
                                    card?.variant === variants.v7 ?
                                    "0px" :
                                    "unset"
                                },
                          right:
                              isTangerineV15 && !isTangerineV15FullwidthImage ?
                                "unset" :
                              !isTwoUp &&
                                card?.flipDirection &&
                                card?.flipDirection?.toLowerCase() === "yes" ?
                              "revert" :
                              isTangerineV14 || isTangerineV15 ?
                              { sm: "0px" } :
                              { md: "0px" },
                          top: isTangerineV15 && !isTangerineV15FullwidthImage ? "unset" : "0px",
                          zIndex: 1,
                          alignItems: "center",
                          padding: card?.variant === variants.v8 && {
                            xs: "0px",
                            md: "90px 0px 0px 0px"
                          },
                          ...(card?.variant === variants.v8 && {
                            maxWidth: { xl: "900px" }
                          }),
                          width: isTangerineV15  ?
                            (isTangerineV15FullwidthImage ?
                                  {
                                      xs: "100%",
                                      sm: "100%",
                                      md: "100%",
                                      lg: "100%",
                                      xl: "100%"
                                    } :
                                  {
                                      xs: "100%",
                                      sm: "50%",
                                      md: "50%",
                                      lg: "50%",
                                      xl: "50%"
                                    }) :
                            {
                                xs: "100%",
                                sm: isTangerineV14 ?
                                  "calc(100vw/1440*(0.40*1440))" :
                                  "100%",
                                md:
                                  isTwoUp || card?.variant === variants.v12 ?
                                    "100%" :
                                    card?.variant === variants.v3 ||
                                      card?.variant === variants.v5 ||
                                      card?.variant === variants.v7 ?
                                    "50%" :
                                    isOneUpBullet ?
                                    "40%" :
                                    isTangerineV14 ?
                                    "auto" :
                                    "calc(100vw/1440*(0.45*1440))",
                                lg:
                                  isTwoUp || card?.variant === variants.v12 ?
                                    "100%" :
                                    card?.variant === variants.v3 ||
                                      card?.variant === variants.v5 ||
                                      card?.variant === variants.v7 ?
                                    "50%" :
                                    isOneUpBullet ?
                                    "40%" :
                                    isTangerineV14 ?
                                    "auto" :
                                    "calc(100vw/1600*(0.45*1600))",
                                xl:
                                  isTwoUp || card?.variant === variants.v12 ?
                                    "100%" :
                                    card?.variant === variants.v3 ||
                                      card?.variant === variants.v5 ||
                                      card?.variant === variants.v7 ?
                                    "50%" :
                                    isOneUpBullet ?
                                    "50%" :
                                    isTangerineV14 ?
                                    "auto" :
                                    "calc(100vw/1920*(0.45*1920))"
                              },
                          ...(isTangerineV15 && {
                            height: 'auto',
                            order: card?.contentOrder?.image || 1,
                            ...(isTangerineV15FullwidthImage ?
                              {
                                  position: "relative",
                                  height: "100%",
                                  width: "100%",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  order: isTangerineV15ImageFirst ? 1 : 2
                                } :
                              {
                                  minHeight: {
                                    sm: "100%",
                                    md: "100%",
                                    lg: "100%",
                                    xl: "100%"
                                  },
                                  alignSelf: "stretch",
                                  borderRadius: {
                                    xs: isTangerineV15ImageFirst ?
                                      "10px 10px 0px 0px" :
                                      "0px 0px 10px 10px",
                                    sm: isTangerineV15ImageFirst ?
                                      "10px 0px 0px 10px" :
                                      "0px 10px 10px 0px"
                                  }
                                })
                          })
                        }}
                      >
                        <picture
                          style={
                            isTangerineV15FullwidthImage ?
                              {
                                  display: "block",
                                  height: '100%',
                                  width: "100%"
                                } :
                              undefined
                          }
                        >
                          <source
                            media={`(min-width: ${DtvTheme.breakpoints.values.md}px)`}
                            srcSet={`${lgImageUrl}?noretina=true 1x, ${lgImageUrl} 2x`}
                          />
                          <source
                            media={`(min-width: ${DtvTheme.breakpoints.values.sm}px)`}
                            srcSet={`${mdImageUrl}?imwidth=900&noretina=true 1x, ${mdImageUrl}?imwidth=900 2x`}
                          />
                          <img
                            alt={card?.image?.imageAlt || ""}
                            id={`card-image-1up-${props?.id}-${index}`}
                            loading={props?.aboveTheFold ? 'eager' : 'lazy'}
                            srcSet={`${sxImageUrl}?imwidth=600&noretina=true 1x, ${sxImageUrl}?imwidth=600 2x`}
                            style={{
                              marginTop: "0px",
                              width: "100%",
                              height: "100%",
                              display: isTangerineV15FullwidthImage ? "block" : undefined,
                              objectFit: isTangerineV15 ? (card?.imageFit ?? "cover") : "cover",
                              objectPosition: isTangerineV15 ? (card?.imagePosition ?? 'center center') : undefined,
                              borderRadius:
                                card?.variant === variants.v8 ?
                                  "10px 0px 10px 10px" :
                                  isTangerineV15 ?
                                  isTangerineV15ImageFirst ?
                                    isTangerineV15FullwidthImage ?
                                      "10px" :
                                      isTangerineV15Mobile ?
                                      "10px 10px 0px 0px" :
                                      "10px 0px 0px 10px" :
                                    isTangerineV15FullwidthImage ?
                                    "10px" :
                                    isTangerineV15Mobile ?
                                    "0px 0px 10px 10px" :
                                    "0px 10px 10px 0px" :
                                  isTangerineV15Mobile ?
                                  "0px" :
                                  "10px"
                            }}
                          />
                        </picture>
                      </DtvBox>
                      {(card?.variant === variants.v1 ||
                        card?.variant === variants.v10 ||
                        card?.variant === variants.v2 ||
                        card?.variant === variants.v9 ||
                        card?.variant === variants.v4) && (
                        <DtvBox
                          aria-hidden={true}
                          sx={{
                            borderRadius: "10px",
                            position: "absolute",
                            backgroundImage: {
                              xs: `linear-gradient(${
                                card?.variant === variants.v1 ||
                                card?.variant === variants.v2 ||
                                card?.variant === variants.v9 ?
                                  "360deg" :
                                  "180deg"
                              }, 
                              ${bgColor} ${
                                isv4TwoUp &&
                                card?.gradientStop1 &&
                                card?.gradientStop1?.BelowDesktop ?
                                  card?.gradientStop1?.BelowDesktop :
                                  "45%"
                              }, 
                             transparent ${
                               isv4TwoUp &&
                               card?.gradientStop2 &&
                               card?.gradientStop2?.BelowDesktop ?
                                 card?.gradientStop2?.BelowDesktop :
                                 "65%"
                             })`,
                              md:
                                !isTwoUp &&
                                card?.flipDirection &&
                                card?.flipDirection?.toLowerCase() === "yes" ?
                                  `linear-gradient(90deg, 
                            transparent, transparent 35%, ${bgColor} 53%)` :
                                  `linear-gradient(${
                                      isTwoUp ? "180deg" : "90deg"
                                    }, ${bgColor}, ${bgColor} ${
                                      isv4TwoUp &&
                                      card?.gradientStop1 &&
                                      card?.gradientStop1?.FromDesktop ?
                                        card?.gradientStop1?.FromDesktop :
                                        "50%"
                                    }, 
                              transparent ${
                                isv4TwoUp &&
                                card?.gradientStop2 &&
                                card?.gradientStop2?.FromDesktop ?
                                  card?.gradientStop2?.FromDesktop :
                                  "65%"
                              })`
                            },
                            ...(card?.variant === variants.v10 && {
                              backgroundImage: {
                                xs: `linear-gradient(${"to top"}, ${bgColor} ${
                                  card?.xs?.gradientPercentage
                                }, transparent ${
                                  card?.xs?.gradientTransparency
                                })`,
                                sm: `linear-gradient(${"to top"}, ${bgColor} ${
                                  card?.sm?.gradientPercentage
                                }, transparent ${
                                  card?.sm?.gradientTransparency
                                })`,
                                md: `linear-gradient(${
                                  card?.flipDirection ? "-90deg" : "90deg"
                                },${bgColor} ${
                                  card?.md?.gradientPercentage
                                }, transparent ${
                                  card?.md?.gradientTransparency
                                })`,
                                xl: `linear-gradient(${
                                  card?.flipDirection ? "-90deg" : "90deg"
                                },${bgColor} ${
                                  card?.xl?.gradientPercentage
                                }, transparent ${
                                  card?.xl?.gradientTransparency
                                })`
                              }
                            }),
                            zIndex: 3,
                            height: "100%",
                            left: "0px",
                            top: "0px",
                            width: "100%",
                            mixBlendMode: "initial"
                          }}
                        />
                      )}
                      <DtvBox
                        sx={{
                          marginTop: {
                            xs: card?.xs?.paddingTop,
                            sm: card?.sm?.paddingTop,
                            md: card?.md?.paddingTop,
                            xl: card?.xl?.paddingTop
                          },
                          marginBottom: {
                            xs: card?.xs?.paddingBottom,
                            sm: card?.sm?.paddingBottom,
                            md: card?.md?.paddingBottom,
                            xl: card?.xl?.paddingBottom
                          },
                          borderRadius: "10px",
                          bottom: {
                            xs:
                              card?.variant === variants.v1 ||
                              card?.variant === variants.v10 ||
                              card?.variant === variants.v2 ||
                              card?.variant === variants.v9 ||
                              card?.variant === variants.v7 ?
                                "0px" :
                                "unset",
                            md:
                              card?.variant === variants.v1 ||
                              card?.variant === variants.v2 ||
                              card?.variant === variants.v9 ?
                                "0px" :
                                "unset"
                          },
                          alignItems:
                            card?.variant === variants.v8 ?
                              {
                                  xs: "center",
                                  sm: "center",
                                  md: "flex-start"
                                } :
                              isTangerineV14 ?
                              {
                                  xs: "center",
                                  sm: "flex-start",
                                  md: "flex-start"
                                } :
                              card?.variant === variants.v7 ?
                              "flex-start" :
                              "center",
                          display: "flex",
                          flexDirection: "column",
                          height: {
                            xs: card?.variant === variants.v7 ? "60%" : "auto",
                            sm:
                              card?.variant === variants.v7 ?
                                "30%" :
                                isTangerineV14 || isTangerineV15 ?
                                "inherit" :
                                "auto",
                            md: isTwoUp ?
                              "auto" :
                              "inherit"
                          },
                          justifyContent: {
                            xs:
                              card?.variant === variants.v3 ||
                              card?.variant === variants.v10 ||
                              card?.variant === variants.v4 ||
                              card?.variant === variants.v5 ?
                                "unset" :
                                "center",
                            md:
                              card?.variant === variants.v7 ?
                                "unset" :
                                "center",
                            ...(card?.variant === variants.v8 && {
                              xs: "left",
                              md: "unset"
                            })
                          },
                          position: isTangerineV15 ? "relative" : "absolute",
                          zIndex: 3,
                          textAlign:
                            card?.variant === variants.v7 ? "" : "center",
                          ...(card?.variant === variants.v8 && {
                            xs: "center",
                            sm: "center",
                            md: "left"
                          }),
                          ...((isTangerineV14 || isTangerineV15) && {
                            textAlign: {
                              xs: "center",
                              sm: "left",
                              md: "left"
                            }
                          }),

                          ...(card?.variant === variants.v10 && {
                            mx: {
                              md: isDesktop ? "5%" : card?.md?.paddingX
                            }
                          }),
                          padding: {
                            xs:
                              card?.variant === variants.v3 ||
                              card?.variant === variants.v4 ||
                              card?.variant === variants.v5 ?
                                "0 20px 0px 20px" :
                                card?.variant === variants.v7 ?
                                "0px 20px 0px 20px" :
                                isOneUpBullet ?
                                "0px" :
                                card?.v2Styles?.padding?.xs || "20px",
                            sm:
                              card?.variant === variants.v3 ||
                              card?.variant === variants.v4 ||
                              card?.variant === variants.v5 ?
                                "0 40px 0px 40px" :
                                card?.variant === variants.v7 ?
                                "20px 0px 0px 20px" :
                                isOneUpBullet ?
                                "0px" :
                                card?.v2Styles?.padding?.sm || "40px",
                            md:
                              isTwoUp &&
                              (card?.variant === variants.v3 ||
                                card?.variant === variants.v4) ?
                                "0 34px 0 34px" :
                                card?.variant === variants.v7 ?
                                "50px 0px 0px 20px" :
                                card?.variant === variants.v3 && !isTwoUp ?
                                "40px 0px 40px 40px" :
                                (card?.variant === variants.v4 && !isTwoUp) ||
                                  (card?.variant === variants.v5 && !isTwoUp) ?
                                "40px" :
                                isOneUpBullet ?
                                "0px" :
                                card?.v2Styles?.padding?.md || "0 40px 0px 40px",
                            xl: isTwoUp ?
                              "80px" :
                              card?.variant === variants.v7 ?
                              "130px 0px 0px 130px" :
                              isOneUpBullet ?
                              "0px" :
                              card?.v2Styles?.padding?.xl || "80px 80px 80px 80px",
                            ...(card?.variant === variants.v8 && {
                              xs: "61px 20px 0px 20px",
                              sm: "69px 0px",
                              md: "133px 0px 95px 60px",
                              xl: "133px 0px 95px 60px"
                            })
                          },
                          color: isTangerineV15FullwidthImage ?
                            card?.mode === "dark" ?
                              "#FAFAFA" :
                              "#102641" :
                            card?.backgroundColor === "none" ||
                              card?.mode === "dark" ?
                            "#102641" :
                            "#FAFAFA",
                          left: isTangerineV15 ?
                            "unset" :
                            {
                                xs: (card?.variant === variants.v7 || isTangerineV14 || isTangerineV15) ? "0px" : "unset",
                                md:
                                  !isTwoUp &&
                                  card?.flipDirection &&
                                  card?.flipDirection.toLowerCase() === "yes" ?
                                    "revert" :
                                    card?.variant === variants.v7 ?
                                    "unset" :
                                    !isTwoUp && "0px"
                              },
                          right:
                            isTangerineV15 ?
                              "unset" :
                              (!isTwoUp &&
                                  card?.flipDirection &&
                                  card?.flipDirection.toLowerCase() === "yes") ||
                                card?.variant === variants.v7 ?
                              "0px" :
                              "unset",
                          ...(card?.variant === variants.v10 && {
                            right: {
                              xs: "unset",
                              md: "0px"
                            }
                          }),
                          width: {
                            xs:
                              card?.variant === variants.v7 ?
                                "unset" :
                                isOneUpBullet ?
                                "295px" :
                                card?.v2Styles?.width?.xs || "100%",
                            sm:
                              card?.variant === variants.v7 ?
                                "unset" :
                                isOneUpBullet ?
                                "470px" :
                                isTangerineV14 || (isTangerineV15 && !isTangerineV15FullwidthImage) ?
                                card?.v2Styles?.width?.sm || "55%" :
                                "100%",
                            md: isTwoUp ?
                              "100%" :
                              card?.variant === variants.v7 ?
                              "45%" :
                              card?.variant === variants.v8 ?
                              "50%" :
                              isOneUpBullet ?
                              "470px" :
                              isTangerineV15FullwidthImage ?
                              "100%" :
                              card?.v2Styles?.width?.md || "55%"
                          },
                          top:
                            (card?.variant === variants.v3 ||
                              card?.variant === variants.v4 ||
                              card?.variant === variants.v8 ||
                              card?.variant === variants.v5) &&
                            "0px",
                          ...(isTangerineV14 && {
                            top: {
 xs: "32px",
sm: "0px"
}
                          }),
                          ...(isTangerineV15 && {
                            order: card?.contentOrder?.content || 1,
                            position: "relative",
                            left: "unset",
                            right: "unset",
                            top: "unset",
                            marginTop: {
                              xs: "0px",
                              sm: "0px",
                              md: "0px"
                            },
                            marginBottom: {
                              xs: "0px",
                              sm: "0px",
                              md: "0px"
                            },
                            height: "auto",
                            zIndex: 3,
                            ...(isTangerineV15FullwidthImage ?
                              {
                                  position: "absolute",
                                  top: 0,
                                  bottom: 0,
                                  left: {
                                    xs: 0,
                                    sm: contentAlignment === "right" ? "auto" : 0,
                                    md: contentAlignment === "right" ? "auto" : 0
                                  },
                                  right: {
                                    xs: 0,
                                    sm: contentAlignment === "left" ? "auto" : 0,
                                    md: contentAlignment === "left" ? "auto" : 0
                                  },
                                  ...(contentAlignment === "center" && {
                                    margin: {
 xs: "0",
sm: "0 auto",
md: "0 auto"
}
                                  }),
                                  height: "100%",
                                   alignItems: {
                                    xs: "center",
                                    sm: contentAlignment === 'center' ? 'center' : 'flex-start',
                                    md: contentAlignment === 'center' ? 'center' : 'flex-start'
                                  },
                                  justifyContent: {
                                    xs: v15FwMobileJustify,
                                    sm: "center",
                                    md: "center"
                                  },
                                  padding: {
                                    xs: "40px 20px 16px 20px",
                                    sm: "48px 20px 40px 32px",
                                    md: contentAlignment === "center" ? "56px 64px 48px 64px" : "56px 64px 48px 96px"
                                  },
                                  width: {
                                    xs: "100%",
                                    sm: "50%",
                                    md: "50%"
                                  },
                                  borderRadius: 'unset',
                                  rowGap: {
                                    xs: "8px",
                                    sm: "8px",
                                    md: "8px"
                                  }
                                } :
                              {
                                  alignItems: {
                                    xs: "center",
                                    sm: "flex-start",
                                    md: "flex-start"
                                  },
                                  justifyContent: {
                                    xs: "flex-start",
                                    sm: 'center',
                                    md: "center",
                                    lg: 'center'
                                  },
                                  textAlign: {
                                    xs: "center",
                                    sm: "left",
                                    md: "left"
                                  },
                                  padding: {
                                    xs: "32px 20px 16px 20px",
                                    sm: "40px 20px 40px 32px",
                                    md: "48px 64px 48px 96px"
                                      },
                                  width: {
                                        xs: "100%",
                                        sm: card?.v2Styles?.width?.sm || "50%",
                                        md: card?.v2Styles?.width?.md || "50%"
                                      },
                                  rowGap: {
                                    xs: "8px",
                                    sm: "8px",
                                    md: "8px"
                                  },
                                  alignSelf: "stretch"
                                })
                          }),
                          ...(card?.variant === variants.v11 && {
                            top: { xs: "0" },
                            justifyContent: { md: "flex-start" },
                            alignItems: { md: "flex-start" },
                            padding: {
                              md: "45px 52px 0px 52px",
                              xs: "40px 20px 0 20px"
                            },
                            textAlign: { md: "left" }
                          }),
                          ...(card?.variant === variants.v12 && {
                            top: "0",
                            left: "auto",
                            width: { md: "70%" },
                            justifyContent: { md: "flex-start" },
                            alignItems: { md: "center" },
                            padding: {
                              md: "45px 52px 0px 52px",
                              xs: "40px 20px 0 20px"
                            },
                            textAlign: { md: "center" }
                          })
                        }}
                      >
                        {(card?.variant === variants.v3 ||
                          card?.variant === variants.v4 ||
                          card?.variant === variants.v5 || isTangerineV15) && (
                          <DtvText
                            aria-label={card?.eyebrow?.content}
                            component={card?.eyebrow?.component || "div"}
                            content={card?.eyebrow?.content}
                            id={`eyebrow-copy-${props?.id}-${index}`}
                            variant="eyebrow"
                            sx={{
                              pb: {
                                xs: isv3V4TwoUp ? "20px" : "24px",
                                sm: isv3V4TwoUp ? "20px" : "32px",
                                md: isv3V4TwoUp ? "32px" : "auto"
                              },
                              ...(isTangerineV15 && {
                                color: card?.eyebrow?.color || (card?.mode === "dark" ? "#FAFAFA" : "#121212"),
                                 fontSize: {
                                  xs: '16px',
                                  sm: '15px',
                                  md: '16px'
                                 }
                              }),
                              textDecoration: "none",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              pt: {
                                xs: "48px",
                                sm: "64px",
                                md: isv3V4TwoUp ?
                                  "52px" :
                                  isTwoUp ?
                                  "72px" :
                                  "0px",
                                xl: "unset"
                              },
                              ...(isTangerineV15 ? TANGERINE_V15_EYEBROW_SX : {}),
                              ...(isTangerineV15FullwidthImage && {
                                alignItems: {
                                  xs: "center",
                                  sm: contentAlignment === "center" ? "center" : "flex-start",
                                  md: contentAlignment === "center" ? "center" : "flex-start"
                                },
                                pt: {
                                  xs: "0px",
                                  sm: "0px",
                                  md: "0px"
                                },
                                pb: {
                                  xs: "0px",
                                  sm: "0px",
                                  md: "0px"
                                }
                              })
                            }}
                          />
                        )}
                        {/* 1up bullet */}
                        <DtvText
                          aria-label={card?.headline?.content}
                          component={card?.headline?.component || "div"}
                          content={card?.headline?.content}
                          id="card-headline"
                          variant={isTangerineV14 || isTangerineV15 ?  "subhead1medium" : "subhead1"}
                          cta={{
                            label: card?.headline?.cta?.label,
                            legalUrl: card?.headline?.cta?.legalUrl,
                            position: card?.headline?.cta?.position
                          }}
                          sx={{

                            fontFamily:
                              card?.variant === variants.v7 ?
                                "PFDinMed" :
                                isTangerineV14 || isTangerineV15 ?
                                "" :
                                {},
                            fontSize: {
                              xs:
                                card?.variant === variants.v7 ?
                                  "24px" :
                                  card?.variant === variants.v10 ?
                                  "24px" :
                                  isTangerineV14 || isTangerineV15 ?
                                  "24px" :
                                  {},
                              sm:
                                card?.variant === variants.v7 ?
                                  "25px" :
                                  card?.variant === variants.v10 ?
                                  "30px" :
                                  isTangerineV14 || isTangerineV15 ?
                                  "30px" :
                                  {},
                              md:
                                card?.variant === variants.v7 ?
                                  "36px" :
                                  card?.variant === variants.v10 ?
                                  "40px" :
                                  isTangerineV14 || isTangerineV15 ?
                                  "36px" :
                                  {}
                            },
                            maxWidth: {
                              xs:
                                card?.variant === variants.v1 ||
                                card?.variant === variants.v2 ||
                                card?.variant === variants.v9 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    card?.v2Styles?.maxWidth?.xs || "240px" :
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                  "100%" :
                                  "295px",
                              sm:
                                card?.variant === variants.v1 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    "523px" :
                                  card?.variant === variants.v2 ||
                                    card?.variant === variants.v9 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    card?.v2Styles?.maxWidth?.sm || "450px" :
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                  "100%" :
                                  "420px",
                              md:
                                card?.variant === variants.v1 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    "350px" :
                                  card?.variant === variants.v2 ||
                                    card?.variant === variants.v9 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    card?.v2Styles?.maxWidth?.md || "450px" :
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                  "100%" :
                                  "420px",
                              lg:
                                card?.variant === variants.v1 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    "400px" :
                                  card?.variant === variants.v2 ||
                                    card?.variant === variants.v9 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    card?.v2Styles?.maxWidth?.lg || "450px" :
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                  "100%" :
                                  "420px",
                              xl:
                                card?.variant === variants.v1 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    "450px" :
                                  card?.variant === variants.v2 ||
                                    card?.variant === variants.v9 ?
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                    "100%" :
                                    card?.v2Styles?.maxWidth?.xl || "610px" :
                                  card?.isHeadlineFullwidth &&
                                    card?.isHeadlineFullwidth.toLowerCase() ===
                                      "yes" ?
                                  "100%" :
                                  "420px",
                              ...(card?.variant === variants.v8 && {
                                sm: "420px",
                                md: "490px",
                                xl: "490px"
                              })
                            },
                            ...(card?.variant === variants.v10 && {
                              maxWidth: { xs: "100%" }
                            }),
                            ...(isTangerineV14 && {
                              marginTop: { sm: "32px" },
                              color: "#000443"
                            }),
                            ...(isTangerineV15 && {
                              marginTop: "0px",
                              color: card.headline?.color || (card?.mode === "dark" ? "#FAFAFA" : "#121212"),
                              maxWidth: {
 xs: "100%",
sm: "100%",
md: "100%"
},
                              fontWeight: 700
                            }),
                            ...(isTangerineV15FullwidthImage && {
                              color: card.headline?.color || (card?.mode === "dark" ? "#FAFAFA" : "#121212"),
                              maxWidth: {
                                xs: "100%",
                                sm: "100%",
                                md: "100%"
                              }
                            }),
                            ...((card?.variant === variants.v11 ||
                              card?.variant === variants.v12) && {
                              maxWidth: { md: "100%" }
                            })
                          }}
                          tooltip={{
                            content: card?.headline?.tooltip?.content,
                            position: card?.headline?.tooltip?.position,
                            mode: card?.headline?.tooltip?.mode
                          }}
                        />
                        {card?.subheadline?.content && (
                              <DtvText
                                aria-label={card?.subheadline?.content}
                                component={card?.subheadline?.component || "div"}
                                content={card?.subheadline?.content}
                                id={`subheadline-${props?.id}-${index}`}
                                variant="subhead2medium"
                                sx={{
                                  maxWidth: {
 xs: "100%",
md: "auto"
},
                                  ...(isTangerineV15 && {
                                    color: card?.subheadline?.color || (card?.mode === "dark" ? "#FAFAFA" : "#121212")
                                  }),
                                  ...(isTangerineV15 || isTangerineV15FullwidthImage && {
                                     lineHeight: '1.3em'
                                  }),
                                  ...(isTangerineV15FullwidthImage && {
                                    maxWidth: {
                                      xs: "100%",
                                      sm: "100%",
                                      md: "100%"
                                    }
                                  })
                                }}
                              />
                        )}
                        {card?.variant === variants.v10 && (
                          <DtvBox
                            id={`${props?.id}-parent-bullet-desktop`}
                            sx={{
                              textAign: "start",
                              ml: {
 xs: "20px",
sm: 0
},
                              mt: {
                                xs: "20px",
                                sm: "24px",
                                md: "24px"
                              }
                            }}
                          >
                            <Bullets
                              bullets={card?.bullets}
                              id={`${props?.id}-v10-desktop`}
                            />
                          </DtvBox>
                        )}

                        {(card?.variant === variants.v2 ||
                          (isTwoUp && card?.variant === variants.v4) ||
                          card?.variant === variants.v9 ||
                          card?.variant === variants.v7 ||
                          card?.variant === variants.v8 ||
                          card?.variant === variants.v11 ||
                          card?.variant === variants.v12 ||
                          isTangerineV15) && (

                          <DtvText
                            aria-label={card?.body?.content}
                            component={card?.body?.component || "div"}
                            content={card?.body?.content}
                            id={`body-copy-${props?.id}-${index}`}
                            variant="body1"
                            cta={{
                              label: card?.body?.cta?.label,
                              legalUrl: card?.body?.cta?.legalUrl,
                              position: card?.body?.cta?.position
                            }}
                            sx={{
                              maxWidth: {
                                xs:
                                  card?.variant === variants.v7 ?
                                    "90%" :
                                    card?.v2Styles?.bodyTextSize?.xs || "295px",
                                sm:
                                  card?.variant === variants.v7 ?
                                    "90%" :
                                    card?.variant === variants.v8 ?
                                    "470px" :
                                    card?.v2Styles?.bodyTextSize?.sm || "420px"
                              },
                              pt: isv3V4TwoUp ?
                                {
 xs: "20px",
md: "24px"
} :
                                card?.variant === variants.v8 ?
                                "7px" :
                                "20px",
                              pb: isv3V4TwoUp ?
                                {
 xs: "20px",
md: "24px"
} :
                                card?.variant === variants.v8 && {
                                    xs: "10px",
                                    sm: "0px"
                                  },
                              ...((card?.variant === variants.v8 ||
                                card?.variant === variants.v11) && {
                                textAlign: {
                                  md: "start"
                                }
                              }),
                              ...(card?.variant === variants.v11 && {
                                maxWidth: { md: "100%" }
                              }),

                              ...(isTangerineV15 &&
                                (isTangerineV15FullwidthImage ?
                                  {
                                     letterSpacing: 0,
                                      color: card.body?.color || (card.mode === "dark" ?
                                        "#FAFAFA" :
                                        "#121212"),

                                      margin: "0px",
                                      marginTop: "0px",
                                      padding: "0px",
                                      pt: "0px",
                                      pb: "0px",
                                      maxWidth: {
                                        xs: "100%",
                                        sm: "100%",
                                        md: "100%"
                                      }
                                    } :
                                  {
                                      letterSpacing: 0,
                                      color: card?.body?.color || (
                                        card?.mode === "dark" ?
                                          "#FAFAFA" :
                                          "#121212"),
                                      textAlign: {
                                        xs: "center",
                                        sm: "left",
                                        md: "left"
                                      },
                                      margin: "0px",
                                      marginTop: "0px",
                                      padding: "0px",
                                      pt: "0px",
                                      pb: "0px",
                                       maxWidth: {
                                        xs: "100%",
                                        sm: "100%",
                                        md: "100%"
                                      }
                                    }))
                            }}
                            tooltip={{
                              content: card?.body?.tooltip?.content,
                              position: card?.body?.tooltip?.position,
                              mode: card?.body?.tooltip?.mode
                            }}
                          />
                        )}
                        {(card?.variant === variants.v11 ||
                          card?.variant === variants.v12) && (
                          <DtvBox
                            sx={{
                              margin: {
                                md: "32px 0 0 0",
                                sm: "26px auto 0 auto",
                                xs: "16px auto 0 auto"
                              }
                            }}
                          >
                            <DtvCountdownTimer
                              {...card?.countdownTimer}
                              isFullWidth={true}
                              mode={card?.mode}
                              gridGap={{
                                xs: "14px",
                                md: "20px"
                              }}
                              onCountDownTimerExpired={() => {
                                setIsCountDownTimerExpired(true);
                              }}
                            />
                          </DtvBox>
                        )}
                        <CtaContainer
                          analytics={props?.analytics}
                          card={card}
                          hideXS={card?.variant === variants?.v11}
                          id={props?.id}
                          isOneUpBullet={isOneUpBullet}
                          isv3V4TwoUp={isv3V4TwoUp}
                        />
                        {card?.variant === variants.v2 &&
                          card?.optionalCTA?.label && (
                            <Link
                              href={card?.optionalCTA.targeturl}
                              id={`optionalCtaLink-${props?.id}-${index}`}
                              sx={{
                                color: "white.main",
                                textDecorationColor: colorPalette.neutral_white.main,
                                mb: {
 xs: "12px",
sm: "20px",
md: "0px"
},
                                mt: {
 xs: "32px",
md: "40px"
},
                                fontSize: {
 xs: "16px",
xl: "20px"
},
                                lineHeight: "1.3rem",
                                letterSpacing: "-0.02em",
                                fontWeight: 400,
                                fontFamily: "roboto-regular"
                              }}
                              onClick={handleLinkClick}
                            >
                              {" "}
                              {card?.optionalCTA.label}{" "}
                            </Link>
                          )}
                        {card?.variant === variants.v4 &&
                          card?.featuredLogos &&
                          card?.featuredLogos?.length > 0 && (
                            <DtvBox
                              sx={{
                                display: {
                                  xs: "none",
                                  md: isTwoUp ? "none" : "flex"
                                },
                                justifyContent: "center",
                                alignItems: "center",
                                pt: {
 md: "48px",
xl: "64px"
}
                              }}
                            >
                              <FeaturedLogos
                                id={`${props?.id}-desktop`}
                                isTwoUp={isTwoUp}
                                lazyLoadImages={!props?.aboveTheFold}
                                logos={card?.featuredLogos}
                              />
                            </DtvBox>
                          )}
                        {card?.variant === variants.v5 && (
                          <DtvBox
                            sx={{
                              display: {
                                xs: "none",
                                md: isTwoUp ? "none" : "block"
                              },
                              mt: {
 md: "56px",
xl: "64px"
}
                            }}
                          >
                            <Bullets
                              bullets={card?.bullets}
                              id={`${props?.id}-v5-desktop`}
                              isBulletFullwidth={card?.isBulletFullwidth}
                              isTwoUp={isTwoUp}
                            />
                          </DtvBox>
                        )}
                        {(card?.variant === variants.v11 ||
                          card?.variant === variants.v12 || isTangerineV15) && (
                          <DtvBox
                            sx={{
                              margin: "12px 0 0 0",
                              display: {
                                md: "block",
                                xs: "none"
                              },

                              ...((card?.variant === variants.v12 || isTangerineV15) && {
                                display: {
                                  md: "block",
                                  xs: "block"
                                }
                              }),
                              ...(isTangerineV15 && {
                                 color: card?.mode === "dark" ? "#FAFAFA" : "#555555"
                              }),
                              ...(isTangerineV15FullwidthImage && {
                                color: card?.mode === "dark" ?
                                  "#FAFAFA" :
                                  "#555555",
                                maxWidth: {
                                  xs: "100%",
                                  sm: "100%",
                                  md: "100%"
                                }

                              })
                            }}
                          >
                            <DtvText
                              {...card?.legalText}
                              sx={{

                                fontSize: "12px !important",
                                ...(isTangerineV15 && {
                                   color: card?.legalText?.color || (card?.mode === "dark" ? "#FAFAFA" : "#555555"),
                                   letterSpacing: 0,
                                  ...(isTangerineV15FullwidthImage ?
                                    {
                                       letterSpacing: 0
                                      } :
                                    {}),
                                  // WAT-11565: this legal cta renders as <button> now, not <a>.
                                  '& a, & button': {
                                    color: "inherit",
                                    textDecorationColor: "inherit",
                                    '&:active': { color: "inherit" },
                                    '&:hover': { color: "inherit" },
                                    '&:focus': { color: "inherit" }
                                  }
                                })
                              }}
                            />
                          </DtvBox>
                        )}
                      </DtvBox>
                    </DtvBox>
                  </DtvGrid>
                );
              })}
            </>
          )}
        </DtvGrid>
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="DTV Content Cards" error={error} />;
  }
};
